import { PriceUnitOption, priceUnits } from '../../domain'

export function usePriceUnits(): Record<string, PriceUnitOption[]> {
  return {
    priceUnits,
  }
}
